import React from 'react'

import Modal from 'react-bootstrap/Modal'
import {Button} from "react-bootstrap";

import Notify from '../../../utils/Notify'
import General from '../../../utils/General'

export default class GiftingServiceModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ...this._getState(props),
    }

    this.lazyLoadingList = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this._getState(nextProps))
  }

  _getState(props) {
    return {
      ...props,
      show: props.show,
      service: props.service,
      data: props.data ? General.clone(props.data) : {
        base_url: "",
        token: "",
      },
    }
  }

  _handleUpdate() {
    let {
      data
    } = this.state

    const hasBaseUrl = !!data.base_url;
    const hasToken = !!data.token;

    if (hasBaseUrl !== hasToken) {
      Notify.error("Please enter both a url and token");
      return;
    }

    this.props.onUpdated(data);
  }

  render() {
    let {
      show,
      data,
      service,
      loading,
    } = this.state

    return (
      <Modal
        show={show}
        onHide={() => this.props.onHide()}
        centered
        className={`reassign-modal`}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>{service.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="form-group row">
            <label className="col-3 col-form-label">Base URL</label>
            <div className="col-9">
              <input
                className="form-control form-control-solid"
                type="text"
                placeholder="Base URL"
                value={data.base_url}
                onChange={e => {
                  data.base_url = e.target.value
                  this.setState({ data })
                }}
              />
            </div>
          </div>

          <div className="form-group row">
            <label className="col-3 col-form-label">Token</label>
            <div className="col-9">
              <input
                className="form-control form-control-solid"
                type="text"
                placeholder="Token"
                value={data.token}
                onChange={e => {
                  data.token = e.target.value
                  this.setState({ data })
                }}
              />
            </div>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => this.props.onHide()}
          >
            Close
          </Button>
          <Button
            variant="primary"
            disabled={loading}
            onClick={() => this._handleUpdate()}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
